import React, { useState, useEffect } from 'react';
import { donorLogos } from '../data/mockData';

const DonorsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerView = 6;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % donorLogos.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const getVisibleLogos = () => {
    const visible = [];
    for (let i = 0; i < itemsPerView; i++) {
      const index = (currentIndex + i) % donorLogos.length;
      visible.push(donorLogos[index]);
    }
    return visible;
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Our Donors & Partners
          </h2>
          <div className="w-24 h-1 bg-orange-600 mx-auto"></div>
        </div>

        <div className="relative overflow-hidden">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {getVisibleLogos().map((logo, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 flex items-center justify-center group"
              >
                <img
                  src={logo}
                  alt={`Donor ${index + 1}`}
                  className="max-w-full h-20 object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonorsSection;